import { ProductType } from './../models/product.model';
import { ID } from '../models/ID.model';
import { UtilsService } from 'src/app/services/utils.service';
import { AWSRequest } from './../models/aws-request.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Document, DocumentType } from '../models/document.model';
import { map, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DocumentsService {

    constructor(
        private http: HttpClient,
        private utilsService: UtilsService
    ) { }

    downloadDocument(id: ID) {
        return this.http.get<AWSRequest>(`/documentos/${ id }`);
    }
    // En documents.service.ts
    // En documents.service.ts
downloadContract(documentId: ID): Observable<{blob: Blob, filename: string}> {
    return this.http.get(`/documentos/${documentId}`, {
        responseType: 'blob',
        observe: 'response'
    }).pipe(
        map(response => {
            const blob = response.body as Blob;           
            
            let filename = response.headers.get('nombre-archivo') || 'documento';
            
            console.log('Nombre archivo:', filename); // Debug
            
            return { blob, filename };
        })
    );
}

    /**
     * @deprecated usar subida por aws
     */
    uploadDocument(file: File, documentType: DocumentType, signed?: boolean) {
        const formData = new FormData();
        formData.append('file', file);
        return this.http.post<Document>(`/documentos`, formData, { headers: { 'tipo-documento': documentType, firmado: String(signed ?? '') } });
    }

    uploadDocumentAWS(file: File, documentType: DocumentType, productId?: ID, productType?: ProductType, signed?: boolean, category?: string) {
        const headers: { [key: string]: string } = {};
        headers['tipo-documento'] = documentType;
        if (productId)
            headers['id-producto'] = String(productId);
        if (productType)
            headers['tipo-producto'] = productType;
        if (signed)
            headers.firmado = String(signed);
        if (category)
            headers.categoria = category;
        return this.utilsService.uploadFile<Document>(file, '/documentos/url', '/documentos/confirmacion', {}, {}, headers);
    }

    reportSignedDocuments(idDocumentos: ID[]) {
        return this.http.post(`/contratos/firma-digital`, { idDocumentos });
    }
}
